import styled from 'styled-components'

// button styles duplicated from Collections/ViewCollectionModal/style for identical appearance

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
`

export const ModalContainer = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: hidden;
  width: 60vw;
  color: #303030;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);

  @media (max-width: 1280px) {
    width: 70vw;
  }

  @media (max-height: 768px) {
    max-height: 95vh;
    top: 50%;
  }

  @media (max-width: 768px) {
    width: 90vw;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 2.4vw);
  padding: 3.5vh 0;
  margin-left: 1.2vw;
  margin-right: 1.2vw;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-height: 768px) {
    padding: 2vh 0;
  }
`

export const ModalTitle = styled.h2`
  font-size: 1.4vw;
  font-weight: 700;
  margin: 0;
`

export const CloseButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;
  background-color: #eaeaea;

  img {
    width: 12px;
    height: 12px;
  }
`

export const ModalContent = styled.div`
  padding: 1.2vw;
  display: flex;
  flex-direction: column;
  gap: 1.2vh;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  @media (max-height: 768px) {
    padding: 1vh 1.2vw;
    gap: 1vh;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 2.5vh 1.2vw;
  border-top: 1px solid #e0e0e0;
  gap: 15px;
  flex-shrink: 0;

  @media (max-height: 768px) {
    padding: 1.5vh 1.2vw;
  }
`

export const FormGroup = styled.div`
  margin-bottom: 12px;
`

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #303030;
`

export const TextValue = styled.div`
  font-size: 14px;
  color: #303030;
  line-height: 1.6;
`

export const MaterialItem = styled.div`
  font-size: 14px;
  color: #303030;
  line-height: 1.8;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`


export const SaveButton = styled.button`
  background-color: #0090d3;
  color: #fff;
  font-size: 0.9vw;
  font-weight: 700;
  padding: 1.75vh 1.5vw;
  border: none;
  border-radius: 2vw;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5vw;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 1vw;
    height: 1vw;
  }
`

export const DeleteButton = styled.button`
  background-color: transparent;
  color: #000;
  font-size: 0.9vw;
  font-weight: 700;
  padding: 1.75vh 1.5vw;
  border: 1px solid #ef4444;
  border-radius: 2vw;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5vw;

  &:hover {
    background-color: rgba(239, 68, 68, 0.1);
  }

  img {
    width: 1vw;
    height: 1vw;
    filter: sepia(1) saturate(5) hue-rotate(-10deg);
  }
`

/* original definition
export const DeleteButton = styled.button`
  background-color: transparent;
  color: #000;
  font-size: 14px;
  font-weight: bold;
  padding: 12px 24px;
  border: 1px solid #ef4444;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: rgba(239, 68, 68, 0.1);
  }

  img {
    width: 18px;
    height: 18px;
    filter: sepia(1) saturate(5) hue-rotate(-10deg);
  }
`
*/
